import React from 'react';

import { Button, TabList as ChakraTabList, useMultiStyleConfig, useTab } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const Tab = React.forwardRef((props, ref) => {
  // 1. Reuse the `useTab` hook
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps['aria-selected'];

  // 2. Hook into the Tabs `size`, `variant`, props
  const styles = useMultiStyleConfig('Tabs', tabProps);

  return (
    <Button __css={styles.tab} {...tabProps}>
      <TextBodyMedium bold color={isSelected ? 'text.1565BC' : 'text.g2'}>
        {tabProps.children}
      </TextBodyMedium>
    </Button>
  );
});

export const TabList = styled(ChakraTabList)(({ theme, ...props }) => ({
  '& .chakra-button[aria-selected=true]': {
    borderColor: theme.colors.border['125AA9'],
  },
  boxShadow: '0px 3px 3px #CFD7DF',
  border: 'none',
  paddingLeft: '16px',
}));
